const MINUTE_IN_SECONDS = 60;
const HOUR_IN_SECONDS = 60 * MINUTE_IN_SECONDS;
const DAY_IN_SECONDS = 24 * HOUR_IN_SECONDS;

const relativeFormatter = new Intl.RelativeTimeFormat("tr", {
  numeric: "auto",
});

const toDate = (value) => {
  if (!value) {
    return null;
  }

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatRelativeTime = (value) => {
  const date = toDate(value);

  if (!date) {
    return "Zaman bilgisi yok";
  }

  const diffInSeconds = Math.round((date.getTime() - Date.now()) / 1000);
  const absoluteSeconds = Math.abs(diffInSeconds);

  if (absoluteSeconds < MINUTE_IN_SECONDS) {
    return "Az önce";
  }

  if (absoluteSeconds < HOUR_IN_SECONDS) {
    return relativeFormatter.format(
      Math.round(diffInSeconds / MINUTE_IN_SECONDS),
      "minute"
    );
  }

  if (absoluteSeconds < DAY_IN_SECONDS) {
    return relativeFormatter.format(
      Math.round(diffInSeconds / HOUR_IN_SECONDS),
      "hour"
    );
  }

  return relativeFormatter.format(Math.round(diffInSeconds / DAY_IN_SECONDS), "day");
};

export const formatItemCountLabel = (items = []) => {
  const totalQuantity = items.reduce(
    (sum, item) => sum + Number(item?.quantity || 0),
    0
  );

  if (totalQuantity === 0) {
    return "Ürün yok";
  }

  return `${totalQuantity} ürün`;
};
